import { useEffect, useState, useRef } from 'react'
import { useMotionValue, animate, useInView } from 'framer-motion'
import { AnimatedNumberProps } from './types'

export const AnimatedNumber = ({
  value,
  prefix = '',
  suffix = '',
  duration = 1.5,
  className,
}: AnimatedNumberProps) => {
  const ref = useRef<HTMLSpanElement>(null)
  const isInView = useInView(ref, { once: true })

  const motionValue = useMotionValue(0)
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    if (isInView) {
      const controls = animate(motionValue, value, {
        duration,
        onUpdate: (latest) => {
          setDisplayValue(parseFloat(latest.toFixed(0)))
        },
      })
      return controls.stop
    }
  }, [isInView, value])

  return (
    <span ref={ref} className={className}>
      {prefix}
      {displayValue.toLocaleString()}
      {suffix}
    </span>
  )
}
